import CreateNewProject from "../Profiles/components/Content/components/InnerContent/components/CreateNewProject/CreateNewProject";
import "./style.scss";
export default function GuestCreateNewProject() {
  return (
    <CreateNewProject />
  )
}